import { ApplicationResponseDto } from "src/app/application/shared/services/backend/response/create-application-response.dto";

import { ApplicationFeatureState } from "../../application.state";

export class ApplicationReducerMapperService {
  static mapSuccessResponseToState(
    state: ApplicationFeatureState,
    applicationResponseDto: ApplicationResponseDto,
  ) {
    const mergedApplicationFeatureState: ApplicationFeatureState = {
      ...state,
      applicationId: applicationResponseDto.applicationId,
      applicationDocuments: applicationResponseDto.applicationDocuments,
      error: undefined,
      isBusy: false,
    };

    return mergedApplicationFeatureState;
  }
}
